/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Stat_AddInputs */

const vi_shop_home_stat_add = /** @type {(inputs: Shop_Home_Stat_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thêm số liệu`)
};

/**

* @param {Shop_Home_Stat_AddInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_stat_add = /** @type {((inputs?: Shop_Home_Stat_AddInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Stat_AddInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_stat_add(inputs)
});